import { render, staticRenderFns } from "./DigicoopDragonpaySuccessPageComponent.vue?vue&type=template&id=3fa8ba66&scoped=true&"
import script from "./DigicoopDragonpaySuccessPageComponent.vue?vue&type=script&lang=js&"
export * from "./DigicoopDragonpaySuccessPageComponent.vue?vue&type=script&lang=js&"
import style0 from "./DigicoopDragonpaySuccessPageComponent.vue?vue&type=style&index=0&id=3fa8ba66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa8ba66",
  null
  
)

export default component.exports